<div class="container py-3" style="max-width: 600px;">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h2><i class="bi bi-person text-warning me-2"></i>{{ (isEdit ? 'admin.users.title_edit' : 'admin.users.title_new') | translate }}</h2>
    <button class="btn btn-outline-primary" (click)="goBack()">
      <i class="bi bi-arrow-left me-2"></i>{{ 'back' | translate }}
    </button>
  </div>

  <!-- Form -->
  <div class="card" *ngIf="dataReady">
    <div class="card-body">
      <form ngNativeValidate (ngSubmit)="onSubmit()">
        <fieldset [disabled]="disabled" class="border-0 p-0 m-0">
        <table class="table">
          <tbody>
            <tr>
              <td class="fw-bold" style="width: 35%">{{ 'admin.users.name' | translate }} *</td>
              <td>
                <s-input type="text" name="fullname" [(model)]="user.fullname" [required]="true"></s-input>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">{{ 'username' | translate }} *</td>
              <td>
                <s-input type="text" name="username" [(model)]="user.username" [required]="true"></s-input>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">{{ 'email' | translate }} *</td>
              <td>
                <s-input type="email" name="email" [(model)]="user.email" [required]="true"></s-input>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">{{ 'password' | translate }} {{ isEdit ? '' : '*' }}</td>
              <td>
                <s-input type="password" name="password" [(model)]="user.password" [required]="!isEdit"
                  [placeholder]="isEdit ? ('admin.users.password_keep' | translate) : ''"></s-input>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">{{ 'admin.users.client' | translate }}</td>
              <td>
                <s-select name="id_client" [items]="clients" bindLabel="name" bindValue="id_client"
                  [placeholder]="'admin.users.client_placeholder' | translate"
                  [clearable]="true" [disabled]="disabled" [(model)]="user.id_client">
                </s-select>
                <small class="text-muted">{{ 'admin.users.client_hint' | translate }}</small>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">{{ 'admin.users.rights' | translate }} *</td>
              <td>
                <s-select name="id_group" [items]="groups" bindLabel="name" bindValue="id_group"
                  [placeholder]="'admin.users.rights_placeholder' | translate"
                  [clearable]="false" [disabled]="disabled" [(model)]="user.id_group" [required]="true">
                </s-select>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">{{ 'admin.users.language' | translate }}</td>
              <td>
                <s-select name="lang" [items]="languageOptions" bindLabel="label" bindValue="value"
                  [clearable]="false" [disabled]="disabled" [(model)]="user.lang">
                </s-select>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">{{ 'active' | translate }}</td>
              <td>
                <s-input type="switch" name="active" [(model)]="user.active"></s-input>
              </td>
            </tr>
          </tbody>
        </table>

        </fieldset>
        <!-- Actions -->
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button type="button" class="btn btn-secondary" (click)="goBack()">{{ 'cancel' | translate }}</button>
          <button type="submit" class="btn btn-accent" [disabled]="isSaving || disabled">
            <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!isSaving" class="bi bi-save me-2"></i>{{ (isEdit ? 'save' : 'create') | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
